import { Theme } from "@mui/material/styles";
import { ThemeNames, ThemeMap } from "./themeTypes";
import { productionTheme } from "./productionTheme";
import { testTheme } from "./testTheme";
import { developmentTheme } from "./developmentTheme";
import  natureTheme  from "./natureTheme";
import { everestTheme } from "./everestTheme";
import { systelTheme } from "./systelTheme";

/**
 * Registry di tutti i temi disponibili
 */
export const themeRegistry: ThemeMap = {
    [ThemeNames.PRODUCTION]: productionTheme,
    [ThemeNames.TEST]: testTheme,
    [ThemeNames.DEVELOPMENT]: developmentTheme,
    [ThemeNames.NATURE]: natureTheme,
    [ThemeNames.EVEREST]: everestTheme,
    [ThemeNames.SYSTEL]: systelTheme,
};

/**
 * Funzione per ottenere un tema dal registry
 */
export const getTheme = (themeName: string): Theme => {
    const theme = themeRegistry[themeName];

    if (!theme) {
        console.warn(`Tema "${themeName}" non trovato, utilizzo il tema di produzione`);
        return themeRegistry[ThemeNames.PRODUCTION];
    }

    return theme;
};

/**
 * Funzione per aggiungere un nuovo tema al registry
 */
export const registerTheme = (name: string, theme: Theme): void => {
    themeRegistry[name] = theme;
};